import { useInfiniteQuery } from '@tanstack/react-query';

import { client } from '@/api/common';

import type { PartnerCustomer } from './types';

type Variables = {
  text?: string;
  startDate?: string;
  endDate?: string;
  enabled?: boolean;
  perPage?: number;
};

type CustomersPage = {
  data: PartnerCustomer[];
  meta: {
    page: number;
    totalPages: number;
    totalCount: number;
  };
};

const fetchCustomers = async ({
  pageParam,
  variables,
}: {
  pageParam: number;
  variables: Variables;
}) => {
  const params: Record<string, any> = { page: pageParam };

  if (variables.text) {
    params.text = variables.text;
  }

  if (variables.startDate) {
    params.start_date = variables.startDate;
  }

  if (variables.endDate) {
    params.end_date = variables.endDate;
  }

  if (variables.perPage) {
    params.per_page = variables.perPage;
  }

  const response = await client.get(
    'v2/internal/partners/organizations/customers',
    { params }
  );

  return response.data;
};

export const usePaginatedCustomers = (variables: Variables) => {
  const { enabled = true, ...queryVariables } = variables;

  return useInfiniteQuery({
    queryKey: ['internal/partners/organizations/customers', queryVariables],
    queryFn: ({ pageParam = 1 }) =>
      fetchCustomers({ pageParam, variables: queryVariables }),
    initialPageParam: 1,
    getNextPageParam: (lastPage: CustomersPage) => {
      if (lastPage.meta.page >= lastPage.meta.totalPages) {
        return undefined;
      }
      return lastPage.meta.page + 1;
    },
    enabled,
  });
};
